import { schema } from 'normalizr';

export const statusSchema = new schema.Entity('status');
